import { defineStore } from "pinia";

let id = 0;

export const useNotificationStore = defineStore("notification", {
  state: () => ({
    notifications: []
  }),

  actions: {
    notify({ title, message, type = "info", timeout = 4000 }) {
      const n = { id: id++, title, message, type };
      this.notifications.push(n);

      if (timeout > 0) {
        setTimeout(() => this.remove(n.id), timeout);
      }
    },

    remove(id) {
      this.notifications = this.notifications.filter((n) => n.id !== id);
    }
  }
});
